import axios from "axios";
import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import keycloakClient from "../services/KeycloakClient";
import { KeycloakContext } from "./KeycloakContext";
import { message } from "antd";

export const KeycloakProvider = ({ children }) => {
    const initialState = { isAuthenticated: false, keycloakClient: null };
    const [keycloakState, setKeycloakState] = useState(initialState);
    const keyCloakInitOptions = {
        onLoad: "check-sso",
        redirectUri: window.location.origin + window.location.pathname,
        checkLoginIframe: false,
    }

    const scheduleNotification = (timeToExpire, timeBeforeExpiration, messageContent) => {
        if (timeToExpire > timeBeforeExpiration) {
            setTimeout(() => {
                showNotification(messageContent);
            }, (timeToExpire - timeBeforeExpiration) * 1000);
        }
    };
    const showNotification = (content) => {
        message.warning(content, 5); // Display a warning message for 5 seconds
    };

    const scheduleLogout = (timeToExpire) => {
        setTimeout(() => {
            const currentPage = window.location.href;
            keycloakClient.logout({ redirectUri: currentPage });
        }, timeToExpire * 1000);
    };

    useEffect(() => {
        keycloakClient.init(keyCloakInitOptions).then((isAuthenticated) => {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + keycloakClient.token;
            setKeycloakState({ isAuthenticated, keycloakClient });
            const timeToExpire = keycloakClient.idTokenParsed.exp - keycloakClient.idTokenParsed.iat;

            scheduleNotification(timeToExpire, 300, "Your session will expire in 5 minutes.")
            scheduleNotification(timeToExpire, 60, "Your session will expire in 1 minute.")

            scheduleLogout(timeToExpire);
         });
    }, []);

    return (
        <KeycloakContext.Provider value={keycloakState}>{children}</KeycloakContext.Provider>
    );
};
